import React, { PureComponent } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import _ from "lodash";
import jstz from "jstz";
import moment from "moment-timezone";
import SweetAlert from "sweetalert-react";
import { Loader } from "react-loaders";
import { reactLocalStorage } from "reactjs-localstorage";
import { changeLocation } from "api/Location";
import "../node_modules/font-awesome/css/font-awesome.css";
import { browserHistory } from "react-router";

import "./styles";
import EventEmitter from "./services/event-emitter";
import WelcomePage from "./containers/welcome-page";
import LoginPage from "./containers/login-page";
import RegisterPage from "./containers/register-page";
import JoinPage from "./containers/join-page";
import ResetPasswordPage from "./containers/reset-password-page";
import AccountVerify from "./services/account-verify";
import ResetPassword from "./services/reset-password";
import PromoCodePage from "./containers/promo-code";
import TeamReportsLeftNavigation from "./components/team-reports/navigation/left";
import Auth from "./routes/Auth";
import { getRequest, batchRequest } from "./api/ApiService";
import {
  logError,
  getDateInCurrentTimezone,
  detectMobile
} from "./services/utils";
import TopBar from "./components/navigation/topbar";
import TeamProfilePage from "./components/team-profile-page";
import Teams from "./api/Teams";
import FeedbackModal from "./components/feedback/modal";
import AutoLogout from "./auth/autologout";
import PaymentsPopup from "./components/payments/popup";
import LeftBar from "./components/navigation/leftbar";
import CoachingFeedback from "./components/coaching-feedback";

import Quiz from "./components/quiz/index";
import styled from "styled-components";

import { view } from "@risingstack/react-easy-state";
import Analytics from "./services/analytics";
import AnalyticsSend from "./services/analytics-send";

import { isSurveyFinished } from './api/Surveys';
import DecisionsAlert from "./components/alerts/decisions";

const TIMER_UPDATE_INTERVAL = 60000; // one minute in ms
const ROUND_HAS_ENDED_INTERVAL = 10000; // ten seconds in ms
const CHECK_ROUND_ENDED_INTERVAL = 10000; // one second in ms

const MIN_ROUNDS = 3; // show popup if count of rounds less than current value

const LogoutButton = styled.a`
  display: block;
  margin: 0;
  padding: 0;
  position: absolute;
  top: -200px;
  right: 0;

  &:active,
  &:visited,
  &:link {
    outline: none;
    font-size: 14px;
    text-decoration: underline;
  }

  &:hover {
    text-decoration: none;
  }
`;

class App extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      rounds: [],
      current_round: null,
      roundInUrl: null,
      team_grade: 0,
      rank_name: "",
      team_color: "",
      tourMode: false,
      players: {},
      team_name: "",
      has_team_data: false,
      rounds_loaded: false,
      errorAlert: false,
      errorText: "",
      submitDecisionsAlert: false,
      submitDecisionsText: "",
      submitDecisionsType: "success",
      isMobileMenuOpen: false,
      showPaymentsPopup: false,
      first_name: "",
      last_name: "",
      username: "",
      userPosition: "",
      coachingFeedbackTitle: null,
      coachingFeedbackMessage1: null,
      coachingFeedbackMessage2: null,
      coachingFeedbackMessage3: null,
      coachingFeedbackShow: false,
      roundShouldBeFinished: false,
      instructorRounds: [],
      instructorTeams: [],
      isNextStepsVisited: false,
      showPerformanceFeedbackAlert: false,
      isMenuExpanded: Auth.getMenuState(),
      isPeerFeedbackVisible: false,
      isPerformanceFeedbackVisible: true,
      finishedSurveys: [],
      hasTrivia: false,
      isPeerReviewVisible: false
    };

    this.eventemitter = EventEmitter.getInstance();
    this.need_to_cancel = false;
    this.isMobile = detectMobile();
  }

  setMenuState = isMenuExpanded => {
    this.setState({
      isMenuExpanded,
    }, () => {
      Auth.setMenuState(isMenuExpanded);
      this.eventemitter.trigger('activate-submenu');
    });
  }

  latestFinishedRound = rounds => {
    const finishedRounds = rounds.filter(i => i.is_finished === true);

    return finishedRounds.length > 0
      ? finishedRounds[finishedRounds.length - 1]
      : null;
  };

  get latestFinishedRoundNumber() {
    const { rounds } = this.state;
    const latestFinishedRound = this.latestFinishedRound(rounds);

    return latestFinishedRound ? latestFinishedRound.number : 0;
  }

  showCoachingFeedback = (title, message1, message2, message3) => {
    this.setState(
      {
        coachingFeedbackTitle: title,
        coachingFeedbackMessage1: message1,
        coachingFeedbackMessage2: message2,
        coachingFeedbackMessage3: message3,
      },
      () => {
        this.setState({
          coachingFeedbackShow: true
        });
      }
    );
  };

  sendAnalyticsEvent = location => {
    if (this.state.current_round && Auth.getUserId()) {
      let activeRound = this.state.current_round.number;
      if (this.state.roundInUrl && this.state.roundInUrl !== "") {
        activeRound = this.state.roundInUrl;
      }

      if (
        /^\/ceo\/analysis\/market.*$/.test(location.pathname) === true ||
        /^\/pd\/analysis\/market.*$/.test(location.pathname) === true ||
        /^\/pm\/analysis\/market.*$/.test(location.pathname) === true ||
        /^\/op\/analysis\/market.*$/.test(location.pathname) === true ||
        /^\/fn\/analysis\/market.*$/.test(location.pathname) === true ||
        /^\/analysis\/bcase.*$/.test(location.pathname) === true ||
        /^\/analysis\/team-reports.*$/.test(location.pathname) === true
      ) {
        Analytics.event(activeRound, window, location.pathname);
      }
    }
  };

  setNextStepVisited = () => {
    if (this.state.isNextStepsVisited !== true) {
      this.setState({
        isNextStepsVisited: true,
      });
    }
  }

  componentDidMount() {
    this.unlisten = browserHistory.listen(this.sendAnalyticsEvent);

    this.fetchData(() => this.checkIsPeerFeedbackPagesVisibility());

    this.eventemitter.on("app-show-error", this.errorAlert);
    this.eventemitter.on("reload-data", this.fetchData);
    this.eventemitter.on("submit-decisions-event", this.submitDecisionsEvent);
    this.eventemitter.on("tour-enabled", this.enableTour);
    this.eventemitter.on("tour-disabled", this.disableTour);
    this.eventemitter.on("coaching-feedback", this.showCoachingFeedback);
    this.eventemitter.on("next-steps-visited", this.setNextStepVisited);
    this.eventemitter.on("round-switcher-alert", this.showPerformanceFeedbackAlert);

    setTimeout(() => {
      this.initializeZopimChat();
    }, 1000);

    if (typeof window !== "undefined") {
      window.addEventListener("click", this.handleLogout, false);
    }
  }

  initializeZopimChat = () => {
    if (window.$zopim && window.$zopim.livechat) {
      //window.$zopim.livechat.setOnChatStart(some-callback-here);
    }
  };

  componentDidUpdate() {
    const { location } = this.props;

    this.detectRoundInUrl();
    if (this.isStudent === true) {
      if (Auth.isPaid() === false) {
        if (this.isMobile === true && location.pathname !== "/promo-code") {
          changeLocation("/promo-code");
        } else if (this.state.showPaymentsPopup !== true) {
          this.setState({
            showPaymentsPopup: true
          });
        }
      }
    }
  }

  componentWillUnmount() {
    this.unlisten();

    if (this.check_timer) {
      clearTimeout(this.check_timer);
      this.check_timer = null;
    }

    if (this.rounds_timer) {
      clearTimeout(this.rounds_timer);
      this.rounds_timer = null;
    }

    if (this.rounds_timer2) {
      clearTimeout(this.rounds_timer2);
      this.rounds_timer2 = null;
    }

    if (this.teamGradeRequest) {
      this.teamGradeRequest.abort();
      this.teamGradeRequest = null;
    }

    this.eventemitter.off("app-show-error", this.errorAlert);
    this.eventemitter.off("reload-data", this.fetchData);
    this.eventemitter.off("submit-decisions-event", this.submitDecisionsEvent);
    this.eventemitter.off("tour-enabled", this.enableTour);
    this.eventemitter.off("tour-disabled", this.disableTour);
    this.eventemitter.off("coaching-feedback", this.showCoachingFeedback);
    this.eventemitter.off("next-steps-visited", this.setNextStepVisited);
    this.eventemitter.on("round-switcher-alert", this.showPerformanceFeedbackAlert);

    if (typeof window !== "undefined") {
      window.removeEventListener("click", this.handleLogout);
    }
  }

  showPerformanceFeedbackAlert = () => {
    this.setState({
      showPerformanceFeedbackAlert: true,
    });
  }

  hidePerformanceFeedbackAlert = () => {
    this.setState({
      showPerformanceFeedbackAlert: false,
    });
  }

  updateUserRoles = callback => {
    const joinRequest = batchRequest([
      ...Teams.requests(),
      `${process.env.REACT_APP_API_URL}v2/games/teamplayers/`
    ]);

    joinRequest
      .then(res => {
        const teams_data = [
          {
            status: res[0].statusCode,
            data: res[0].body
          },
          {
            status: res[1].statusCode,
            data: res[1].body
          }
        ];
        const teams_status = Teams.setData(teams_data);
        if (teams_status === "Error") {
          throw teams_status;
        }

        Auth.setPlayerRoles(res[2].body.results);

        if (callback) {
          callback();
        }
      })
      .catch(err => { });
  };

  fetchData = callback => {
    const { location } = this.props;
    const { showPaymentsPopup } = this.state;

    const queryToken = _.get(location, "query._token", null);
    const target = _.get(location, "query._target", null);
    const currentToken = Auth.getToken();

    if (queryToken && (!currentToken || target === "blank")) {
      Auth.setTemporaryUser({
        token: queryToken,
        game_id: _.get(location, "query.game_id", null),
        course_id: _.get(location, "query._courseid", null),
        user_id: _.get(location, "query._userid", null),
        team_id: _.get(location, "query.team_id", null),
      });
    }

    const temporaryUser = Auth.getTemporaryUser();
    if (temporaryUser) {
      Auth.setToken(temporaryUser.token);
      Auth.setPosition("Instructor");
      Auth.setGameId(temporaryUser.game_id);
      Auth.setCourseId(temporaryUser.course_id);
      Auth.setUserId(temporaryUser.user_id);
      Auth.setTeamId(temporaryUser.team_id);

      changeLocation(`${location.pathname}?round=${_.get(location, 'query.round', null)}`);
    }

    const user_data_request = Auth.getUserDataRequest();
    const isStudent = this.isStudent;
    if (user_data_request) {
      getRequest(user_data_request)
        .then(user_data => {
          if (JSON.stringify(user_data.body) !== JSON.stringify(Auth.getUser())) {
            Auth.setUserData(user_data.body);
          }

          const user = user_data.body;
          const first_name = user.first_name;
          const last_name = user.last_name;
          const username = user.username;
          const userPosition = user.role;

          const userData = {};
          if (first_name !== this.state.first_name) {
            userData.first_name = first_name;
          }
          if (last_name !== this.state.last_name) {
            userData.last_name = last_name;
          }
          if (username !== this.state.username) {
            userData.username = username;
          }
          if (userPosition !== this.state.userPosition) {
            userData.userPosition = userPosition;
          }
          if (user.id !== this.state.userId) {
            userData.userId = user.id;
          }

          if (Object.keys(userData).length > 0) {
            this.setState(userData);
          }

          if (isStudent === true) {
            if (Auth.isPaid() === false) {
              if (
                this.isMobile === true &&
                location.pathname !== "/promo-code"
              ) {
                changeLocation("/promo-code");
                this.setState({
                  loaded: true
                });
              } else if (showPaymentsPopup === false) {
                this.setState({
                  showPaymentsPopup: true,
                  loaded: true
                });
              }

              return;
            }
          }
          if (isStudent === true && Auth.getTeamId()) {
            const auth_game_id = Auth.getGameId();

            let requests = [
              `${process.env.REACT_APP_API_URL}games/${auth_game_id}/`,
              `${process.env.REACT_APP_API_URL}game/rounds/`,
              `${process.env.REACT_APP_API_URL}v2/trivia/coursetrivias/`,
            ];

            if (Teams.players().length === 0 || Teams.teams().length === 0) {
              requests = [...requests, ...Teams.requests()];
            }

            const joinRequest = batchRequest(requests);

            joinRequest
              .then(res => {
                let players = {};
                let team_color = "";
                let team_name = "";
                let has_team_data = false;
                let rounds_loaded = false;
                let current_rounds = [];
                let current_round = null;
                let hasRoundEnded = false;

                if (res.length > 3) {
                  const teams_data = [
                    {
                      status: res[3].statusCode,
                      data: res[3].body
                    },
                    {
                      status: res[4].statusCode,
                      data: res[4].body
                    }
                  ];
                  Teams.setData(teams_data);
                }

                Teams.players().forEach(player => {
                  players[player.role] = {
                    first_name: "user" in player ? player.user.first_name : "",
                    last_name: "user" in player ? player.user.last_name : "",
                    team_id: player.team
                  };
                });

                const team = Teams.currentTeam();
                team_color = Teams.currentTeamColor();
                team_name = team ? team.name : "";
                has_team_data = true;

                const res3 = res[0].body;
                const res4 = res[1].body;
                rounds_loaded = true;
                const { round, rounds } = res3;
                current_rounds = res4.filter(i => rounds.includes(i.id));

                current_round = current_rounds.find(i => i.number === 1);
                if (round !== null) {
                  current_round = current_rounds.find(i => i.id === round);
                }

                hasRoundEnded = this.checkIfRoundHasEndedAndSetTimers(
                  current_round,
                  current_rounds
                );
                const interval = hasRoundEnded
                  ? ROUND_HAS_ENDED_INTERVAL
                  : TIMER_UPDATE_INTERVAL;

                setTimeout(this.updateRoundShouldBeFinished, 1000);

                if (this.rounds_timer) {
                  clearTimeout(this.rounds_timer);
                }

                let updateTimer = true;

                const count_of_rounds = current_rounds.length;
                if (
                  current_round &&
                  count_of_rounds > 0 &&
                  current_round.number ===
                  current_rounds[count_of_rounds - 1].number &&
                  hasRoundEnded === true
                ) {
                  updateTimer = false;
                }

                if (this.need_to_cancel === true) {
                  updateTimer = false;
                  this.need_to_cancel = false;
                }

                if (updateTimer === true) {
                  this.rounds_timer = setTimeout(this.fetchData, interval);
                }

                const trivias = res[2].body.results;
                const trivia = trivias.find(i => (
                  Number(i.course) === Number(Auth.getCourseId())
                  && Number(i.trivia.stage) === Number(current_round.number)
                ));
                const hasTrivia = !!trivia;

                const roundData = {};
                if (JSON.stringify(players) !== JSON.stringify(this.state.players)) {
                  roundData.players = players;
                }

                if (team_color !== this.state.team_color) {
                  roundData.team_color = team_color;
                }

                if (team_name !== this.state.team_name) {
                  roundData.team_name = team_name;
                }

                if (has_team_data !== this.state.has_team_data) {
                  roundData.has_team_data = has_team_data;
                }

                if (rounds_loaded !== this.state.rounds_loaded) {
                  roundData.rounds_loaded = rounds_loaded;
                }

                if (JSON.stringify(current_rounds) !== JSON.stringify(this.state.rounds)) {
                  roundData.rounds = current_rounds;
                }

                if (JSON.stringify(current_round) !== JSON.stringify(this.state.current_round)) {
                  roundData.current_round = current_round;
                }

                if (false !== this.state.showPaymentsPopup) {
                  roundData.showPaymentsPopup = false;
                }

                if (true !== this.state.loaded) {
                  roundData.loaded = true;
                }

                if (hasTrivia !== this.state.hasTrivia) {
                  roundData.hasTrivia = hasTrivia;
                }

                if (Object.keys(roundData).length > 0) {
                  this.setState(roundData, () => {
                    this.sendAnalyticsEvent(this.props.location);
                    this.fetchTeamGrade(callback);
                    this.checkIsNextStepsVisited();
                    this.updateUserRoles();
                  });
                } else {
                  this.sendAnalyticsEvent(this.props.location);
                  this.fetchTeamGrade(callback);
                  this.checkIsNextStepsVisited();
                  this.updateUserRoles();
                }
              })
              .catch(err => {
                logError(err, "App", "fetchData");
              });
          } else if (isStudent === false && Auth.getTeamId()) {
            const auth_game_id = Auth.getGameId();

            let requests = [
              `${process.env.REACT_APP_API_URL}games/${auth_game_id}/`,
              `${process.env.REACT_APP_API_URL}game/rounds/`,
              `${process.env.REACT_APP_API_URL}teams/`,
            ];

            if (Teams.players().length === 0 || Teams.teams().length === 0) {
              requests = [...requests, ...Teams.requests()];
            }

            const joinRequest = batchRequest(requests);

            joinRequest
              .then(res => {
                let players = {};
                let team_color = "";
                let team_name = "";
                let has_team_data = false;
                let rounds_loaded = false;
                let current_rounds = [];
                let current_round = null;

                if (res.length > 3) {
                  const teams_data = [
                    {
                      status: res[3].statusCode,
                      data: res[3].body
                    },
                    {
                      status: res[4].statusCode,
                      data: res[4].body
                    }
                  ];
                  Teams.setData(teams_data);
                }

                Teams.players().forEach(player => {
                  players[player.role] = {
                    first_name: "user" in player ? player.user.first_name : "",
                    last_name: "user" in player ? player.user.last_name : "",
                    team_id: player.team
                  };
                });

                const team = Teams.currentTeam();
                team_color = Teams.currentTeamColor();
                team_name = team ? team.name : "";
                has_team_data = true;

                const res3 = res[0].body;
                const res4 = res[1].body;
                rounds_loaded = true;
                const { round, rounds } = res3;
                current_rounds = res4.filter(i => rounds.includes(i.id));

                current_round = current_rounds.find(i => i.number === 1);
                if (round !== null) {
                  current_round = current_rounds.find(i => i.id === round);
                }

                const instructorRounds = current_rounds.filter(i => Number(i.game) === auth_game_id);

                const res5 = res[2].body;

                this.setState(
                  {
                    players,
                    team_color,
                    team_name,
                    has_team_data,
                    rounds_loaded,
                    rounds: instructorRounds,
                    instructorRounds,
                    instructorTeams: res5,
                    current_round,
                    roundInUrl: _.get(location, 'query.round', null),
                    showPaymentsPopup: false,
                    loaded: true
                  },
                  () => {
                    this.fetchTeamGrade(callback);
                  }
                );
              })
              .catch(err => {
                logError(err, "App", "fetchData");
              });
          } else {
            batchRequest([
              `${process.env.REACT_APP_API_URL}courses/`,
              `${process.env.REACT_APP_API_URL}games/`,
              `${process.env.REACT_APP_API_URL}game/rounds/`,
            ]).then(res => {
              const courses = res[0].body;
              const course = courses.length > 0 ? courses[0] : null;
              const courseId = course ? course.id : 0;
              const games = res[1].body.filter(i => i.course === courseId);
              const game = games.length > 0 ? games[0] : null;
              const round = game ? game.round : null;
              const rounds = game ? game.rounds : [];
              const gameId = game ? game.id : 0;
              const instructorRounds = res[2].body.filter(i => (
                i.game === gameId &&
                rounds.includes(i.id)
              ));

              let current_round = null;
              if (round !== null) {
                current_round = instructorRounds.find(i => i.id === round);
              }

              if (!current_round) {
                current_round = instructorRounds.find(i => i.number === 1);
              }

              Auth.setGameId(gameId);
              Auth.setCourseId(courseId);

              this.setState({
                current_round,
                rounds: instructorRounds,
                instructorRounds,
                roundInUrl: _.get(location, 'query.round', null),
                showPaymentsPopup: false,
                loaded: true
              }, () => {
                if (callback) {
                  callback();
                }
              });
            }).catch(err => {
              console.log(err);
            });
          }
        })
        .catch(err => {
          logError(err, "App", "fetchData");
        });
    } else {
      this.setState({
        showPaymentsPopup: false,
        loaded: true
      });
    }

    this.detectRoundInUrl();
  };

  checkIsPeerFeedbackPagesVisibility = () => {
    const { rounds } = this.state;

    const activeRound = this.activeRound;
    const round = rounds.find(i => Number(i.number) === Number(activeRound));
    const isRoundLive = round ? (
      round.is_started === true
      && round.is_finished === false
      && round.should_be_finished === false
    ) : false;

    if (isRoundLive && window.location.pathname !== '/start') {
      this.setState({
        isPerformanceFeedbackVisible: false
      });
    }

    getRequest(`${process.env.REACT_APP_API_URL}v2/forms/surveys/`)
      .then(res => {
        const surveys = res.body.results;
        let finishedSurveys = [];

        let isPeerReviewVisible = false;
        if (surveys.length) {
          isPeerReviewVisible = true;
        }
        this.setState({
          isPeerReviewVisible
        });

        if (surveys && surveys.length > 0) {
          finishedSurveys = surveys.filter(i => isSurveyFinished(i))
        }

        if (finishedSurveys.length) {
          if (!this.isStudent && (!isRoundLive || window.location.pathname !== '/start')) {
            this.setState({
              isPeerFeedbackVisible: true,
              finishedSurveys
            });
          } else {
            const userId = Auth.getUserId();
            const lastFinishedSurveyId = finishedSurveys[finishedSurveys.length - 1].id;
            getRequest(`${process.env.REACT_APP_API_URL}v2/forms/surveys/${lastFinishedSurveyId}/user-score/${userId}`)
              .then(res => {
                const userScore = res.body;

                let isPeerFeedbackVisible = false;

                if (userScore.user_score_question && !isRoundLive)
                  isPeerFeedbackVisible = true;

                this.setState({
                  isPeerFeedbackVisible,
                  finishedSurveys
                });
              })
              .catch(err => { });
          }
        }
      })
      .catch(err => { });
  }

  checkIsNextStepsVisited = () => {
    const { roundInUrl } = this.state;
    const currentRound = this.currentRound;
    const roundNumber = Number(roundInUrl || currentRound);
    const gameId = Number(Auth.getGameId());
    const courseId = Number(Auth.getCourseId());
    const userId = Number(Auth.getUserId());

    getRequest(`${process.env.REACT_APP_API_URL}v2/engagement/tracks/?game=${gameId}&course=${courseId}&user=${userId}&round_number=${roundNumber}`)
      .then(res => res.body.results)
      .then(history => {
        const historyPage = history.find(i => (
          i.page.startsWith(`${window.location.protocol}//${window.location.host}/onboarding/next-steps`)
        ));

        this.setState({
          isNextStepsVisited: !!historyPage,
        });
      })
      .catch(err => { });
  }

  getNumber = str => {
    let val = parseInt(str, 10);
    if (isNaN(val)) {
      return 0;
    }

    return val;
  };

  needRedirect = current_round => {
    const isTimesUpShown =
      reactLocalStorage.get("timesUpModal", "false") === "true";
    const timesUpInfo = reactLocalStorage
      .get("timesUpModalRound", "0::0::0::0")
      .split("::");
    const game_id = this.getNumber(timesUpInfo[0]);
    const user_id = this.getNumber(timesUpInfo[1]);
    const round_number = this.getNumber(timesUpInfo[2]);
    const round_id = this.getNumber(timesUpInfo[3]);
    const original_user_id = this.getNumber(Auth.getUserId());
    const original_game_id = this.getNumber(Auth.getGameId());

    return (
      isTimesUpShown === false ||
      round_number !== current_round.number ||
      round_id !== current_round.id ||
      user_id !== original_user_id ||
      game_id !== original_game_id
    );
  };

  goToDashboard = round => {
    const game_id = this.getNumber(Auth.getGameId());
    const user_id = this.getNumber(Auth.getUserId());

    const hash = `${game_id}::${user_id}::${round.number}::${round.id}`;

    if (this.teamGradeRequest) {
      this.teamGradeRequest.abort();
      this.teamGradeRequest = null;
    }

    this.eventemitter.trigger("disable-team-feedback");
    reactLocalStorage.set("timesUpModal", true);
    reactLocalStorage.set("timesUpModalRound", hash);
    this.rounds_timer2 = setTimeout(() => {
      this.fetchData(() => {
        this.updateUserRoles(() => {
          this.eventemitter.trigger("reload-data");
        });
      });
    }, 3000);
    changeLocation(`/start`);
  };

  checkForRedirect = rounds => {
    const latestFinishedRound = this.latestFinishedRound(rounds);
    if (
      latestFinishedRound &&
      this.needRedirect(latestFinishedRound) === true &&
      window.location.pathname !== "/get-started"
    ) {
      this.goToDashboard(latestFinishedRound);
      return true;
    }

    return false;
  };

  checkIfRoundHasEndedAndSetTimers(current_round, current_rounds) {
    if (Auth.isUserAuthenticated() === false) {
      return;
    }

    if (this.check_timer) {
      clearTimeout(this.check_timer);
      this.check_timer = null;
    }

    if (current_round) {
      const need_redirect = this.checkForRedirect(current_rounds);

      if (need_redirect === true) {
        if (this.rounds_timer) {
          clearTimeout(this.rounds_timer);
          this.rounds_timer = null;
        }

        this.need_to_cancel = true;

        return false;
      } else {
        const end_date = getDateInCurrentTimezone(
          moment(current_round.end_date)
        );
        const now_date = getDateInCurrentTimezone(moment());
        const time = end_date - now_date;

        let round_has_ended = false;

        if (
          time <= 0 &&
          current_round.is_finished !== true &&
          this.state.current_round
        ) {
          if (this.rounds_timer) {
            clearTimeout(this.rounds_timer);
            this.rounds_timer = null;
          }

          this.need_to_cancel = true;

          round_has_ended = true;
          this.setRoundProcessing(() => {
            this.rounds_timer2 = setTimeout(() => {
              this.eventemitter.trigger("update-submit-decisions");
              this.fetchData();
            }, ROUND_HAS_ENDED_INTERVAL);
          });
        } else if (current_round.is_finished === true) {
          round_has_ended = true;
        } else {
          this.check_timer = setTimeout(() => {
            this.checkIfRoundHasEndedAndSetTimers(
              current_round,
              current_rounds
            );
          }, CHECK_ROUND_ENDED_INTERVAL);
        }

        return round_has_ended;
      }
    }

    return false;
  }

  get isStudent() {
    return Auth.getPosition() === "Student" ? true : false;
  }

  detectRoundInUrl = () => {
    const { location } = this.props;
    let roundInUrl = null;

    if (location.query.round) {
      roundInUrl = parseInt(location.query.round, 10);

      if (isNaN(roundInUrl)) {
        roundInUrl = null;
      }
    }

    if (roundInUrl !== this.state.roundInUrl) {
      this.setState(
        {
          roundInUrl
        },
        () => {
          if (this.isStudent) {
            this.fetchTeamGrade(() => this.checkIsPeerFeedbackPagesVisibility());
          }
        }
      );
    }
  };

  get currentRound() {
    const { current_round } = this.state;

    if (!current_round) {
      return 1;
    }

    return current_round.number;
  }

  updateRoundShouldBeFinished = () => {
    const { current_round } = this.state;
    let result = false;

    if (current_round) {
      const end_date = getDateInCurrentTimezone(moment(current_round.end_date));
      const now_date = getDateInCurrentTimezone(moment());

      if (now_date > end_date) {
        result = true;
      }
    }

    if (this.state.roundShouldBeFinished !== result) {
      this.setState(
        {
          roundShouldBeFinished: result
        },
        () => {
          setTimeout(this.updateRoundShouldBeFinished, 1000);
        }
      );
    } else {
      setTimeout(this.updateRoundShouldBeFinished, 1000);
    }
  };

  setRoundProcessing = callback => {
    let current_round = _.cloneDeep(this.state.current_round);
    current_round.should_be_finished = true;

    this.setState(
      {
        current_round
      },
      () => {
        callback();
      }
    );
  };

  errorAlert = errorText => {
    this.setState(
      {
        errorText
      },
      () => {
        this.showErrorAlert();
      }
    );
  };

  showErrorAlert = () => {
    this.setState({
      errorAlert: true
    });
  };

  hideErrorAlert = () => {
    this.setState({
      errorAlert: false
    });
  };

  hideSubmitDecisionsAlert = () => {
    this.setState({
      submitDecisionsAlert: false
    });
  };

  showSubmitDecisionsAlert = () => {
    this.setState({
      submitDecisionsAlert: true
    });
  };

  submitDecisionsEvent = (type, text) => {
    this.setState(
      {
        submitDecisionsType: type,
        submitDecisionsText: text
      },
      () => {
        this.showSubmitDecisionsAlert();
      }
    );
  };

  enableTour = () => {
    this.setState({
      tourMode: true
    });
  };

  disableTour = () => {
    this.setState({
      tourMode: false
    });
  };

  get isRoundsEmpty() {
    const { rounds, rounds_loaded } = this.state;

    return rounds_loaded === true && rounds.length < MIN_ROUNDS;
  }

  get isRound1NotStarted() {
    const { current_round, rounds_loaded } = this.state;
    const game_id = Auth.getGameId();

    return (
      (this.isRoundsEmpty === false &&
        current_round &&
        current_round.is_started === false &&
        this.rolesIsEmpty === false &&
        current_round.number === 1 &&
        rounds_loaded === true) ||
      (this.isRoundsEmpty === false &&
        this.rolesIsEmpty === false &&
        game_id === 0 &&
        rounds_loaded === true)
    );
  }

  get isRoundsLoaded() {
    const { rounds_loaded } = this.state;

    return (
      this.isRoundsEmpty === false &&
      rounds_loaded === true &&
      this.isRound1NotStarted === false
    );
  }

  get rolesIsEmpty() {
    const role = Auth.getRole();

    if (
      role !== "CEO" &&
      role !== "PD" &&
      role !== "PM" &&
      role !== "OP" &&
      role !== "FI" &&
      role !== "VI"
    ) {
      return true;
    }

    return false;
  }

  get isRoundProcessing() {
    const { current_round, roundShouldBeFinished } = this.state;
    const game_id = Auth.getGameId();

    return (
      roundShouldBeFinished === true &&
      current_round &&
      current_round.is_finished === false &&
      game_id !== 0
    );
  }

  get round1StartText() {
    const { current_round } = this.state;

    if (!current_round) {
      return "";
    }

    const timezone = jstz.determine();
    let startDate = moment(current_round.start_date)
      .tz(timezone.name())
      .format("MM/DD/YYYY hh:mmA");
    return `Round 1 starts ${startDate}`;
  }

  logout = () => {
    if (Auth.isUserAuthenticated()) {
      Auth.deauthenticateUser();
      window.location.reload();
    }
  };

  handleLogout = e => {
    const element = e.target;

    if (
      element.tagName === "A" &&
      element.classList.contains("sweetalert-logout-button")
    ) {
      e.preventDefault();
      this.logout();
    }
  };

  fetchTeamGrade = callback => {
    if (Teams.players().length === 0 || Teams.teams().length === 0) {
      return;
    }

    const { has_team_data, rounds, roundInUrl } = this.state;
    const base_url = `${process.env.REACT_APP_API_URL}team/grading/`;

    let current_round =
      localStorage.getItem("data") || this.state.current_round;

    if (this.isStudent === false || has_team_data === false || !current_round) {
      return;
    }

    // detect active round
    let activeRound = current_round.number;
    if (roundInUrl !== null && roundInUrl !== current_round.number) {
      activeRound = roundInUrl;
    }

    // get round object
    let round = rounds.find(i => i.number === activeRound);
    if (!round) {
      return;
    }

    if (round.is_started === false) {
      return;
    }

    if (round.should_be_finished === true && round.is_finished === false) {
      return;
    }

    if (round.is_started === true && round.is_finished === false) {
      activeRound -= 1;
      if (activeRound < 1) {
        return;
      }

      round = rounds.find(i => i.number === activeRound);
      if (!round) {
        return;
      }
    }

    // generate team grade url
    const url = `${base_url}?round_number=${round.number}`;

    if (this.teamGradeRequest) {
      this.teamGradeRequest.abort();
      this.teamGradeRequest = null;
    }
    this.teamGradeRequest = getRequest(url);

    this.teamGradeRequest
      .then(res => {
        let team_grade = 0;
        let rank_name = "Unknown Rank";

        const obj = res.body.find(i => i.round === round.id);
        if (obj) {
          team_grade = obj.weighted_value * 100;
          if (obj.ranking !== "") {
            rank_name = obj.ranking;
          }
        }

        const teamGradeData = {};
        if (team_grade !== this.state.team_grade) {
          teamGradeData.team_grade = team_grade;
        }

        if (rank_name !== this.state.rank_name) {
          teamGradeData.rank_name = rank_name;
        }

        if (Object.keys(teamGradeData).length > 0) {
          this.setState(teamGradeData, () => {
            if (callback) {
              callback();
            }
          });
        } else {
          if (callback) {
            callback();
          }
        }
      })
      .catch(err => {
        logError(err, "App", "fetchTeamGrade");
      });
  };

  get activeRound() {
    const { roundInUrl } = this.state;
    const currentRound = this.currentRound;

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      return roundInUrl;
    }

    return currentRound;
  }

  closeMobileMenu = () => {
    if (this.isMobile) {
      this.setState({
        isMobileMenuOpen: false
      });
    }
  };

  handleMobileMenuState = state => {
    this.setState({
      isMobileMenuOpen: state.isOpen
    });
  };

  coachingFeedbackOnClose = e => {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      coachingFeedbackShow: false
    });
  };

  render() {
    const {
      loaded,
      rounds,
      roundInUrl,
      team_grade,
      rank_name,
      team_color,
      tourMode,
      errorAlert,
      errorText,
      submitDecisionsAlert,
      submitDecisionsText,
      submitDecisionsType,
      showPaymentsPopup,
      coachingFeedbackShow,
      coachingFeedbackTitle,
      coachingFeedbackMessage1,
      coachingFeedbackMessage2,
      coachingFeedbackMessage3,
      first_name,
      last_name,
      instructorRounds,
      roundShouldBeFinished,
      username,
      isNextStepsVisited,
      showPerformanceFeedbackAlert,
      instructorTeams,
      isMenuExpanded,
      isPeerFeedbackVisible,
      hasTrivia,
      isPeerReviewVisible,
      isPerformanceFeedbackVisible,
      finishedSurveys
    } = this.state;

    const currentRound = this.currentRound;
    const { location, children, params } = this.props;
    const isStudent = this.isStudent;
    const latestFinishedRoundNumber = this.latestFinishedRoundNumber;
    const appWrapperClassName =
      location.pathname === "/team-reports"
        ? "app-wrapper team-reports-wrapper"
        : "app-wrapper";

    if (loaded === false) {
      return (
        <div className="application-loading">
          <Loader type="ball-scale-ripple" active />
        </div>
      );
    }
    if (location.pathname === "/login") {
      return <LoginPage location={location} />;
    }

    if (location.pathname === "/welcome") {
      return <WelcomePage />;
    }

    if (location.pathname === "/register") {
      return <RegisterPage />;
    }

    if (location.pathname === "/join") {
      return <JoinPage />;
    }

    if (location.pathname === "/reset-password") {
      return <ResetPasswordPage />;
    }

    if (location.pathname === "/forms") {
      return <Quiz userId={this.state.userId} />;
    }

    if (location.pathname === "/promo-code") {
      return <PromoCodePage />;
    }

    const pathes = location.pathname.split("/").filter(i => i !== "");
    if (pathes.length === 2 && pathes[0] === "verify") {
      const { token } = params;
      return <AccountVerify token={token} />;
    }

    if (pathes.length === 3 && pathes[0] === "reset-password") {
      const { token1, token2 } = params;
      return <ResetPassword token1={token1} token2={token2} />;
    }

    const fullname = `${first_name} ${last_name}`;

    return (
      <div id="outer-container">
        {isStudent === true && (
          <div>
            <SweetAlert
              show={this.isRound1NotStarted}
              title="Round 1 has not started yet!"
              text={this.round1StartText}
              confirmButtonText="Logout"
              onConfirm={this.logout}
            />
            <SweetAlert
              show={this.rolesIsEmpty}
              type="warning"
              title="Warning"
              text="This user has not any role. Please add specific role for this user."
              confirmButtonText="Logout"
              onConfirm={this.logout}
            />
            <SweetAlert
              show={this.isRoundProcessing}
              type="warning"
              title="Warning"
              text={renderToStaticMarkup(
                <div>
                  Currently processing round. Please be patient.
                  <LogoutButton href="/#" className="sweetalert-logout-button">
                    Logout
                  </LogoutButton>
                </div>
              )}
              showConfirmButton={false}
              html
            />
          </div>
        )}
        <SweetAlert
          show={errorAlert}
          title="Warning"
          text={errorText}
          type="warning"
          onConfirm={this.hideErrorAlert}
        />
        {submitDecisionsAlert && <DecisionsAlert
          title={
            submitDecisionsType === "success"
              ? "Submission Successful"
              : submitDecisionsType === "warning"
                ? "Submission Successful"
                : submitDecisionsType === "info"
                  ? "Heads Up!"
                  : "Submission Failed"
          }
          message={submitDecisionsText}
          type={submitDecisionsType}
          onHide={this.hideSubmitDecisionsAlert}
        />}
        <SweetAlert
          show={showPerformanceFeedbackAlert}
          title="Warning"
          text="You'll need to review your performance feedback before you will be able to navigate to the next round."
          type="warning"
          onConfirm={this.hidePerformanceFeedbackAlert}
        />
        <CoachingFeedback
          team_color={team_color}
          title={coachingFeedbackTitle}
          message1={coachingFeedbackMessage1}
          message2={coachingFeedbackMessage2}
          message3={coachingFeedbackMessage3}
          onClose={this.coachingFeedbackOnClose}
          show={coachingFeedbackShow}
        />

        <div className="flex">
          {
            <TopBar
              isStudent={isStudent}
              team_color={team_color}
              location={location}
              currentRound={currentRound}
              roundInUrl={roundInUrl}
              rank_name={rank_name}
              team_grade={team_grade}
              rounds={rounds}
              latestFinishedRoundNumber={latestFinishedRoundNumber}
              isMobile={this.isMobile}
              activeRound={this.activeRound}
              name={isStudent ? fullname : username}
              position={this.state.userPosition}
              instructorTeams={instructorTeams}
              isMenuExpanded={isMenuExpanded}
              setMenuState={this.setMenuState}
            />
          }
          <div id="app-wrapper" className={appWrapperClassName}>
            <LeftBar
              latestFinishedRoundNumber={latestFinishedRoundNumber}
              isStarted={this.isRound1NotStarted}
              years={{ data: rounds }}
              rounds={rounds}
              currentRound={currentRound}
              roundInUrl={roundInUrl}
              location={location}
              isStudent={isStudent}
              isRoundsLoaded={this.isRoundsLoaded}
              closeMobileMenu={this.closeMobileMenu}
              isMobile={this.isMobile}
              activeRound={this.activeRound}
              team_name={this.state.team_name}
              position={this.state.userPosition}
              instructorRounds={instructorRounds}
              isNextStepsVisited={isNextStepsVisited}
              isMenuExpanded={isMenuExpanded}
              isPeerFeedbackVisible={isPeerFeedbackVisible}
              hasTrivia={hasTrivia}
              isPeerReviewVisible={isPeerReviewVisible}
              isPerformanceFeedbackVisible={isPerformanceFeedbackVisible}
              finishedSurveys={finishedSurveys}
            />
            {location.pathname === "/team-reports" &&
              this.isMobile === false && <TeamReportsLeftNavigation />}
            {isStudent === true &&
              React.Children.map(children, child =>
                React.cloneElement(child, {
                  rounds,
                  currentRound,
                  roundInUrl,
                  team_color,
                  rank_name,
                  team_grade,
                  tourMode,
                  roundShouldBeFinished
                })
              )}
            {isStudent === false &&
              React.Children.map(children, child =>
                React.cloneElement(child, {
                  rounds: instructorRounds,
                  currentRound,
                  roundInUrl,
                  isMenuExpanded,
                })
              )}
            {isStudent === true && <TeamProfilePage />}
            {isStudent === true && (
              showPaymentsPopup === true ||
              (pathes.length === 2 && pathes[0] === 'checkout' && pathes[1] === 'success') ||
              (pathes.length === 2 && pathes[0] === 'checkout' && pathes[1] === 'cancel')
            ) && (
                <PaymentsPopup
                  isSuccess={pathes.length === 2 && pathes[0] === 'checkout' && pathes[1] === 'success'}
                  isCancel={pathes.length === 2 && pathes[0] === 'checkout' && pathes[1] === 'cancel'}
                />
              )}
          </div>
          {location.pathname !== "/team-reports"}
        </div>
        {isStudent === true &&
          rank_name !== "" &&
          latestFinishedRoundNumber > 0 && (
            <FeedbackModal
              rank_name={rank_name}
              team_color={team_color}
              round_number={this.activeRound}
            />
          )}
        <AutoLogout />
        <AnalyticsSend />
      </div>
    );
  }
}

export default view(App);



// WEBPACK FOOTER //
// ./src/App.js